module.exports = __webpack_public_path__ + "static/img/weather_019.c96a8238.svg";